/* unplugin-vue-components disabled */import script from "./AICopilot.vue?vue&type=script&setup=true&lang=js"
export * from "./AICopilot.vue?vue&type=script&setup=true&lang=js"

import "./AICopilot.vue?vue&type=style&index=0&id=5f933f50&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f933f50"]])

export default __exports__